import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { CommonErrorCode, WorkbookErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IErrorDetail } from './ContentActionNotification';
import { ServerService } from './ServerService';

export class WorkbookErrors {

  public static $inject = ['$translate', 'ServerService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ServerService: ServerService) { }

  public errorDetailsFor(workbookErrorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
    return {
      itemName: workbookErrorItem.item.name,
      itemUrl:
        workbookErrorItem.error.code === CommonErrorCode.WorkbookNotFound
          ? null
          : this.workbookUrl(workbookErrorItem.item),
      errorMessage: this.errorMessageFor(workbookErrorItem)
    };
  }

  private workbookUrl(workbook: IWorkbookBase): string {
    const siteUrls = siteUrlsSelector(appStore.getState());
    return siteUrls ? siteUrls.workbookUrl(workbook.id) : '';
  }

  public errorMessageFor(errorItem: IErrorItem<IWorkbookBase>) {
    const workbook = errorItem.item;
    switch (errorItem.error.code) {
      case WorkbookErrorCode.WorkbookDescriptionTooLong:
        return this.$translate.instant('errorWorkbookDescriptionTooLong', { MAX_LENGTH: this.ServerService.maxDescriptionLength() });
      case CommonErrorCode.WorkbookNotFound:
        return this.$translate.instant('errorWorkbookNotFound', { WORKBOOK_NAME: L10n.elideIfLong(workbook.name) });
      case WorkbookErrorCode.WorkbookDisabled:
        return this.$translate.instant('errorWorkbookDisabled', { WORKBOOK_NAME: L10n.elideIfLong(workbook.name) });
      case WorkbookErrorCode.WorkbookNameAlreadyExistsInDestinationProject:
        return this.$translate.instant('errorWorkbookNameAlreadyExistsInDestinationProject');
      case WorkbookErrorCode.WorkbookDestinationProjectNotFound:
        return this.$translate.instant('errorWorkbookDestinationProjectNotFound');
      case WorkbookErrorCode.WorkbookNameAlreadyExists:
        return this.$translate.instant('errorWorkbookNameAlreadyExists');

      // Permissions errors
      // TODO: Do we want specific error messages for each of these cases?
      case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnDestinationProject:
      case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnSourceProject:
      case WorkbookErrorCode.WorkbookMoveInsufficientPermissionsOnWorkbook:
        return this.$translate.instant('errorWorkbookMoveInsufficientPermissions');
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return this.$translate.instant('errorWorkbookInsufficientPermissions');

      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('WorkbookErrors', WorkbookErrors);
